import MarkerClusterer from "./markerclustererplus";

const ORIGIN_MARKER_ICON =
	"m11 6c-.9889 0-1.95561.29325-2.77785.84265-.82225.54941-1.46311 1.3303-1.84155 2.24393-.37844.91362-.47745 1.91892-.28453 2.88892.19293.9699.66913 1.8608 1.3684 2.56.69926.6993 1.59017 1.1755 2.56003 1.3684.97.193 1.9753.0939 2.8889-.2845s1.6945-1.0193 2.2439-1.8415c.5495-.8223.8427-1.789.8427-2.7779 0-1.32608-.5268-2.59785-1.4645-3.53553-.9376-.93769-2.2094-1.46447-3.5355-1.46447zm0 8c-.5933 0-1.17336-.1759-1.66671-.5056-.49335-.3296-.87787-.7982-1.10493-1.3463-.22706-.5482-.28647-1.1514-.17072-1.7334.11576-.58191.40148-1.11646.82104-1.53602s.95411-.70528 1.53602-.82104c.582-.11575 1.1852-.05634 1.7334.17072.5481.22706 1.0167.61158 1.3463 1.10493.3297.49335.5056 1.07341.5056 1.66671 0 .7956-.3161 1.5587-.8787 2.1213s-1.3257.8787-2.1213.8787zm0-14c-2.91637.00330842-5.71234 1.1633-7.77452 3.22548s-3.22217158 4.85815-3.22548 7.77452c0 3.925 1.81375 8.085 5.25 12.0312 1.54403 1.7833 3.28182 3.389 5.1812 4.7876.1682.1177.3685.1809.5738.1809s.4056-.0632.5738-.1809c1.8959-1.3992 3.6303-3.0049 5.1712-4.7876 3.4312-3.9462 5.25-8.1062 5.25-12.0312-.0033-2.91637-1.1633-5.71234-3.2255-7.77452s-4.8581-3.22217158-7.7745-3.22548zm0 25.75c-2.06625-1.625-9-7.5938-9-14.75 0-2.38695.94821-4.67613 2.63604-6.36396s3.97701-2.63604 6.36396-2.63604c2.3869 0 4.6761.94821 6.364 2.63604 1.6878 1.68783 2.636 3.97701 2.636 6.36396 0 7.1537-6.9338 13.125-9 14.75z";
const DESTINATION_MARKER_ICON =
	"M11 0C8.08363 0.00330842 5.28766 1.1633 3.22548 3.22548C1.1633 5.28766 0.00330842 8.08363 0 11C0 14.925 1.81375 19.085 5.25 23.0312C6.79403 24.8145 8.53182 26.4202 10.4312 27.8188C10.5994 27.9365 10.7997 27.9997 11.005 27.9997C11.2103 27.9997 11.4106 27.9365 11.5788 27.8188C13.4747 26.4196 15.2091 24.8139 16.75 23.0312C20.1812 19.085 22 14.925 22 11C21.9967 8.08363 20.8367 5.28766 18.7745 3.22548C16.7123 1.1633 13.9164 0.00330842 11 0Z";
const clusterStyles = [
	{
		// textColor: "var(--theme-color-text-black)",
		textColor: "yellow",
		url: THEME_OBJ.template_directory + "/images/cluster_images/m1.png",
		height: 50,
		width: 50,
	},
	{
		textColor: "yellow",
		url: THEME_OBJ.template_directory + "/images/cluster_images/m1.png",
		height: 50,
		width: 50,
	},
	{
		textColor: "yellow",
		url: THEME_OBJ.template_directory + "/images/cluster_images/m1.png",
		height: 50,
		width: 50,
	},
];

export default class GoogleMap {
	constructor(options = null) {
		this.mapEl = document.getElementById("map");
		if (!this.mapEl || "undefined" === typeof google) return;
		this.userOptions = JSON.parse(options);
		this.markers = [];
		this.init();
		this.events();
		this.selectFlag = false;
	}

	init() {
		this.directionsService = new google.maps.DirectionsService();
		this.directionsRenderer = new google.maps.DirectionsRenderer({
			polylineOptions: {
				strokeColor: "#868279",
				strokeOpacity: 1,
			},
			suppressMarkers: true,
		});

		this.response = "";
		this.defaultOptions = {
			lat: "36.1783961",
			lng: "28.0007389",
			zoom: 16,
			zoomControl: false,
			scaleControl: true,
			styles: "",
			scrollwheel: true,
			places_categories: false,
			streetViewControl: false,
			disableDoubleClickZoom: false,
			mapTypeControl: false,
			fullscreenControl: false,
			locations: [],
		};

		this.options = {
			...this.defaultOptions,
			...this.userOptions,
		};

		this.swiper =
			document.querySelector(".list-card-items .swiper") &&
			document.querySelector(".list-card-items .swiper").swiper;

		// let bounds = new google.maps.LatLngBounds();

		this.map = new google.maps.Map(this.mapEl, {
			zoom: this.options.zoom,
			zoomControl: this.options.zoomControl,
			scaleControl: this.options.scaleControl,
			scrollwheel: this.options.scrollwheel,
			styles: this.options.styles ?? "",
			streetViewControl: this.options.streetViewControl,
			disableDoubleClickZoom: this.options.disableDoubleClickZoom,
			mapTypeControl: this.options.mapTypeControl,
			fullscreenControl: this.options.fullscreenControl,
			center: {
				lat: parseFloat(this.options.lat),
				lng: parseFloat(this.options.lng),
			},
		});

		const locationPopUpInfoHTML =
			'<div class="location-popup-info">' +
			'<img class="restaurant-bar-img bg-gray" id="restaurantBarIMG" src="." alt="The image">' +
			'<span class="restaurant-bar-title" id="restaurantBarTitle"></span>' +
			'</div>';


		this.infoWindow = new google.maps.InfoWindow({
			content: locationPopUpInfoHTML
		});


		this.buildMarkers.bind(this)(this.options.locations);

		this.directionsRenderer.setMap(this.map);
	}

	buildMarkers(locations = null) {
		if (!locations) return;

		// const locationPopUpInfo = document.createElement("div");
		// // locationPopUpInfo.classList.add('location-popup-info', 'pointer-events-none', 'opacity-0', 'z-[99]', 'absolute', 'flex', 'flex-col', 'min-w-[300px]', 'shadow-[0px_5px_5px_0px_rgba(0,0,0,0.25)]', 'bg-[color:var(--theme-color-white)]', 'rounded-sm');
		// locationPopUpInfo.classList.add("location-popup-info");
		// document.body.appendChild(locationPopUpInfo);


		this.clearMarkers.bind(this)();
		this.markers = [];

		if (Object.keys(locations).length) {
			Object.entries(locations).map((loc) => {
				let icon = {
					path: ORIGIN_MARKER_ICON,
					fillColor: "#868279",
					fillOpacity: 1,
					strokeWeight: 0,
					rotation: 0,
					scale: 1,
					size: new google.maps.Size(22, 28),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(11, 28),
				};

				let m = this.addMarker.bind(this)(icon, {
					lat: parseFloat(loc[1].lat),
					lng: parseFloat(loc[1].lng),
				});

				const locationElements = document.querySelectorAll(
					".list-card-items .swiper .item-card"
				);


				let itemIndex = 0;

				m.addListener("click", (ev) => {
					if (this.swiper.wrapperEl.classList.contains('hidden')) {
						this.swiper.wrapperEl.classList.remove('hidden');
					}
					this.map.setCenter(m.getPosition());
					this.map.panTo(m.getPosition());

					this.swiper && this.swiper.slideTo(itemIndex);

				});

				m.addListener("mouseover", (ev) => {

					this.infoWindow.open({
						anchor: m,
						map,
					});

					itemIndex = Array.from(locationElements).findIndex(
						(item) =>
							parseFloat(item.dataset.locationLat).toFixed(4).toString() ===
								parseFloat(loc[1].lat).toFixed(4).toString() &&
							parseFloat(item.dataset.locationLng).toFixed(4).toString() ===
								parseFloat(loc[1].lng).toFixed(4).toString()
					);

					document.getElementById("restaurantBarIMG").src =
						locationElements[itemIndex].dataset.locationImg;
					document.getElementById("restaurantBarTitle").textContent =
						locationElements[itemIndex].dataset.locationTitle;


					// locationPopUpInfo.style.top = ev.domEvent.pageY + "px";
					// locationPopUpInfo.style.left = ev.domEvent.pageX + "px";
					// locationPopUpInfo.classList.add("show");
				});

				m.addListener("mouseout", (ev) => {
					// locationPopUpInfo.classList.remove("show");
					document.getElementById("restaurantBarIMG").src = "";
					document.getElementById("restaurantBarTitle").textContent = "";
					this.infoWindow.close();

				});

				this.markers.push(m);
			});

			this.mapClusterer = new MarkerClusterer(this.map, this.markers, {
				ignoreHidden: true,
				// imagePath: THEME_OBJ.template_directory + "/images/cluster_images/m",
				// title: "A",
				styles: clusterStyles,
			});
		}
	}

	resetAllMarkersIcon(marker = null) {
		this.markers.map((m) => {
			if (m === marker) {
				m.setIcon({
					path: DESTINATION_MARKER_ICON,
					fillColor: "#868279",
					fillOpacity: 1,
					strokeWeight: 0,
					rotation: 0,
					scale: 1,
					size: new google.maps.Size(22, 28),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(11, 28),
				});
			} else {
				m.setIcon({
					path: ORIGIN_MARKER_ICON,
					fillColor: "#868279",
					fillOpacity: 1,
					strokeWeight: 0,
					rotation: 0,
					scale: 1,
					size: new google.maps.Size(22, 28),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(11, 28),
				});
			}
		});
	}

	selectMarker(m) {

		if (!m) return;

		this.map.setCenter(m.getPosition());
		this.map.panTo(m.getPosition());
		this.map.setZoom(16);

		this.resetAllMarkersIcon.bind(this)(m);
	}

	clearMarkers() {
		for (let i = 0; i < this.markers.length; i++) {
			this.markers[i].setMap(null);
		}

		this.mapClusterer && this.mapClusterer.clearMarkers();
	}

	calculateAndDisplayRoute(originPin, destinationPin, extra = {}) {
		return new Promise((resolve, reject) =>
			this.directionsService.route(
				{
					origin: {
						query: originPin,
					},
					destination: {
						query: destinationPin,
					},
					travelMode: google.maps.TravelMode.DRIVING,
				},
				(response, status) =>
					status === "OK" ? resolve(response) : reject(status)
			)
		).then(
			(response) => {
				this.directionsRenderer.setDirections(response);

				this.directionsRenderer.setMap(null);

				this.clearMarkers.bind(this)();

				const image = {
					url: `${THEME_OBJ.template_directory}/svg/icon-map-pin.svg`,
					// anchor: new google.maps.Point(0, 32),
					// size: new google.maps.Size(20, 32),
				};

				const originMarker = this.addMarker.bind(this)(
					{
						path: ORIGIN_MARKER_ICON,
						fillColor: "#868279",
						fillOpacity: 1,
						strokeWeight: 0,
						rotation: 0,
						scale: 1,
						size: new google.maps.Size(22, 28),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(11, 28),
					},
					{
						lat: parseFloat(originPin.split(",")[0]),
						lng: parseFloat(originPin.split(",")[1]),
					}
				);

				const destinationMarker = this.addMarker.bind(this)(
					{
						path: DESTINATION_MARKER_ICON,
						fillColor: "#868279",
						fillOpacity: 1,
						strokeWeight: 0,
						rotation: 0,
						scale: 1,
						size: new google.maps.Size(22, 28),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(11, 28),
					},
					{
						lat: parseFloat(destinationPin.split(",")[0]),
						lng: parseFloat(destinationPin.split(",")[1]),
					}
				);

				this.markers.push(originMarker);
				this.markers.push(destinationMarker);

				this.directionsRenderer.setMap(this.map);

				window.dispatchEvent(
					new CustomEvent("gmap.responseRoute", {
						detail: {
							response: response.routes[0].legs[0],
							extra,
						},
					})
				);
			},
			(reject) => console.log("Directions request failed due to " + reject)
		);
	}

	addMarker(icon = null, position) {
		return new google.maps.Marker({
			position,
			map: this.map,
			icon: icon ? icon : false,
			draggable: false,
			zIndex: -20,
		});
	}

	setMarkers(ev) {
		if (Object.keys(ev.detail.locations).length) {
			this.buildMarkers.bind(this)(ev.detail.locations);
		} else {
			this.clearMarkers.bind(this)();
		}
	}

	events() {
		window.addEventListener(
			"gmap.calculateAndDisplayRoute",
			(ev) => {
				if (ev.detail && ev.detail?.origin && ev.detail?.destination) {
					this.calculateAndDisplayRoute.bind(this)(
						ev.detail.origin,
						ev.detail.destination,
						{ container: ev.detail?.container }
					);
				}
			},
			false
		);

		window.addEventListener(
			"gmap.selectMarker",
			(ev) => {
				this.selectMarker.bind(this)(this.markers[ev.detail.realIndex]);
			},
			false
		);


		window.addEventListener(
			"gmap.setMarkers",
			(ev) => {
				this.setMarkers.bind(this)(ev);
			},
			false
		);
	}
}
